/**
 * "NO DRAWER IS OPEN", ON A MONEY SHEET, WITH THE WAY OUT IN IT (Unit C).
 *
 * One component for four sheets — settle, split tender, refund, overpayment
 * refund — because they were four copies of the same paragraph and, when the
 * remedy stopped being a link to the back office and became a one-tap open, they
 * would have become four copies of that too. Three of the four never had a remedy
 * at all: they stated the refusal and left the cashier to work out the rest.
 *
 * `onOpenDrawer` is omitted for anyone without the drawer rung. The sentence they
 * see is different (it names who to ask), and offering them a button whose only
 * outcome is a refusal is the dead instruction this whole branch exists to remove.
 */
export function DrawerWarning({
  message,
  actionLabel,
  onOpenDrawer,
  testId,
}: {
  /** The refusal, already branched on authority by the caller. */
  message: string;
  actionLabel: string;
  onOpenDrawer?: () => void;
  /** Each sheet keeps its own id — the specs and the QA scripts name them. */
  testId: string;
}) {
  return (
    <p
      role="alert"
      className="rounded-[var(--radius-list)] bg-[color:var(--warning-100,var(--surface-alt))] px-3 py-2 text-xs font-bold text-[color:var(--warning)]"
      data-testid={testId}
    >
      {message}
      {onOpenDrawer ? (
        <>
          {" "}
          {/* A BUTTON, not a link: it opens a drawer OVER this sheet and leaves
              the bill where it is. The link it replaced navigated to the back
              office, which mid-service means the cashier takes the cash and
              records nothing — the untracked payment D25 exists to prevent,
              caused by the screen meant to prevent it. */}
          <button
            type="button"
            className="underline"
            onClick={onOpenDrawer}
            data-testid={`${testId}-link`}
          >
            {actionLabel}
          </button>
        </>
      ) : null}
    </p>
  );
}
